export default function LoadingFallback({ minHeight = "100vh", backgroundColor = "transparent" }) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight,
        backgroundColor,
        width: "100%",
      }}
    >
      <img
        src="/assets/images/logo-color.svg"
        alt="Rainbow Agro"
        style={{
          width: "150px",
          height: "auto",
          animation: "pulse 1.5s ease-in-out infinite",
        }}
      />
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}
      </style>
    </div>
  );
}
